
    import '/opt/buildhome/repo/components/x-stream/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["components-x-stream-demo-default-protocol","components-x-stream-demo-custom-protocol"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/components/x-stream/index.zh-CN.md?type=demo')
};